import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CentroCustosComponent } from './centro-custos.component';

const routes: Routes = [
  {
    path: '',
    component: CentroCustosComponent,
  },
  {
    path: '',
    component: CentroCustosComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CentroCustosRoutingngModule { }
